import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
// material-ui icons
import List from '@material-ui/icons/List';
// our components
import StatsPeriod from 'components/common/StatsPeriod/StatsPeriod';
import Stats from 'components/common/Stats/Stats';
import gql from 'graphql-tag';

export const NEW_ADS_QUERY = gql`
  query newAds($minDate: Date!, $maxDate: Date!) {
    createdAdsStats(minDate: $minDate, maxDate: $maxDate) {
      total
    }
  }
`;

const AdStatsContainer = ({ t }) => (
  <StatsPeriod query={NEW_ADS_QUERY}>
    {({ data, updateData }) => (
      <Stats
        title={t('dashboard.new_ads')}
        color="warning"
        icon={<List />}
        data={data && data.createdAdsStats ? data.createdAdsStats.total : 0}
        statsUpdate={date => updateData(date)}
      />
    )}
  </StatsPeriod>
);

AdStatsContainer.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(AdStatsContainer);
